export default "__VITE_ASSET__CtMN1SjR__"